import Util from '@/helper/Utility.js';

export function AddCartModel() {
    this.list = [];
    this.mode = 'add';
    this.clearCart = false;
    this.remark = [];

    /**
     * Add item to cart.
     * @param {string|number} campaignId
     * @param {number} qty
     */
    this.addItem = (campaignId, qty) => {
        this.list.push({
            id: campaignId,
            qty: qty
        });
    };
    /**
     * Set cart mode.
     * @param {String} mode
     */
    this.setMode = mode => {
        this.mode = mode;
    };

    this.setRemark = remark => {
        this.remark = remark;
    };

    this.setClearCart = () => {
        this.clearCart = true;
    };
    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        var params = {
            json: JSON.stringify(this.list),
            mode: this.mode,
            clearCart: this.clearCart,
            remark: JSON.stringify(this.remark),
        }

        return Util.cleanObjectEmptyStr(params);
    };

    this.getParamsItem = () => {
        var params = {
            clearCart: this.clearCart
        }

        return Util.cleanObjectEmptyStr(params);
    };

    this.getList = () => {
        var params = {
            id: this.list[0].id
        }

        return Util.cleanObjectEmptyStr(params);
    };

    this.getRemarks = () => {
        var params = {
            clearCart: this.clearCart,
            remark: JSON.stringify(this.remark),
        }

        return Util.cleanObjectEmptyStr(params);
    };
}
